// extracted by mini-css-extract-plugin
module.exports = {"note":"LinkedAccountBalanceUpdating__note__W4X-z","icon":"LinkedAccountBalanceUpdating__icon__GTpWw"};